const browserNames = {
  MS_EDGE: 'MS Edge',
  EDGE_CHROMIUM: 'Edge (chromium based)',
  OPERA: 'Opera',
  CHROME: 'Chrome',
  MS_IE: 'MS IE',
  FIREFOX: 'Mozilla Firefox',
  SAFARI: 'Safari',
  OTHER: 'Other',
};

function getBrowserName(agent = window.navigator.userAgent.toLowerCase()) {
  switch (true) {
    case agent.indexOf('edge') > -1:
      return browserNames.MS_EDGE;
    case agent.indexOf('edg/') > -1:
      return browserNames.EDGE_CHROMIUM;
    case agent.indexOf('opr') > -1 && !!window.opr:
      return browserNames.OPERA;
    case agent.indexOf('chrome') > -1 && !!window.chrome:
      return browserNames.CHROME;
    case agent.indexOf('trident') > -1:
      return browserNames.MS_IE;
    case agent.indexOf('firefox') > -1:
      return browserNames.FIREFOX;
    case agent.indexOf('safari') > -1:
      return browserNames.SAFARI;
    default:
      return browserNames.OTHER;
  }
}

export function isChrome() {
  return getBrowserName() === browserNames.CHROME;
}

export function getRedirectUrl(sourceUrl, analysisId) {
  const getUrl = window.location;
  const baseUrl = `${getUrl.protocol}//${getUrl.host}/redirect`;
  const targetUrl = new URL(baseUrl);
  targetUrl.searchParams.append('redirectUrl', sourceUrl);
  targetUrl.searchParams.append('analysisId', analysisId);
  return targetUrl;
}
